import * as THREE from 'three'

import { loadShader, VERT_SHADER_NAME, FRAG_SHADER_NAME } from './baseGem'
import vertexShader from '../../../trillion-viewer/src/assets/shaders/diamonds/DiamondShader2_2_010923.frag?raw'

const customDiamondShader = true

export interface IGem {
  name: string
  getUniforms(
    jewelry: THREE.Mesh,
    loadResorceTasks: Promise<THREE.Texture | string>[],
  ): Promise<{
    resources: (THREE.Texture | string)[]
    uniforms: { [uniform: string]: THREE.IUniform }
  }>
}

export function isGemIncludedInJewelry(gem: IGem, jewelry: THREE.Mesh): boolean {
  return jewelry.name.toLowerCase().startsWith(gem.name)
}

export async function getMaterialForGem(
  gem: IGem,
  jewelry: THREE.Mesh,
): Promise<THREE.ShaderMaterial> {
  const loadVertShader = loadShader(VERT_SHADER_NAME)
  const loadFragShader = loadShader(FRAG_SHADER_NAME)
  const tasks: Promise<THREE.Texture | string>[] = [loadVertShader, loadFragShader]
  const { resources, uniforms } = await gem.getUniforms(jewelry, tasks)

  if (customDiamondShader) {
    resources.pop()
  }

  const material = new THREE.ShaderMaterial({
    uniforms: uniforms,
    fragmentShader: customDiamondShader ? vertexShader as string : resources.pop() as string,
    vertexShader: resources.pop() as string,
  })

  return material
}
